import React from 'react'

export const QuizzesIcon: React.FC<{ fill?: string }> = ({
  fill = '#BCB1B0',
}) => (
  <svg width="24" height="24">
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h24v24H0z" />
      <rect width="8" height="8" x="3" y="3" fill={fill} rx="1.5" />
      <path
        fill={fill}
        d="M9.5 13a1.5 1.5 0 011.5 1.5v5A1.5 1.5 0 019.5 21h-5A1.5 1.5 0 013 19.5v-5A1.5 1.5 0 014.5 13h5zm10 0a1.5 1.5 0 011.5 1.5v5a1.5 1.5 0 01-1.5 1.5h-5a1.5 1.5 0 01-1.5-1.5v-5a1.5 1.5 0 011.5-1.5h5zm0-10A1.5 1.5 0 0121 4.5v5a1.5 1.5 0 01-1.5 1.5h-5A1.5 1.5 0 0113 9.5v-5A1.5 1.5 0 0114.5 3h5z"
      />
    </g>
  </svg>
)
